import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'mwo-equalizer-icon',
  templateUrl: './equalizer-icon.component.html',
  styleUrls: ['./equalizer-icon.component.scss']
})
export class EqualizerIconComponent implements OnInit {
  @Input() timeslotColor: string;
  @Input() isAnimated: boolean;
  @ViewChild('svgElement', { static: true, read: ElementRef }) svgElement: ElementRef<SVGSVGElement>;

  constructor() {
  }

  ngOnInit() {
  }

}
